import { applyMove } from './applyMove.js';
import { isInCheck } from './attacks.js';
import { generateCastling } from './castling.js';
import { generatePseudoLegal } from './moveGen.js';
import type { Move, Position } from './types.js';

/** Every legal move for the side to move. */
export function generateLegalMoves(pos: Position): Move[] {
  const legal: Move[] = [];
  for (const move of generatePseudoLegal(pos)) {
    if (!isInCheck(applyMove(pos, move).board, pos.turn)) legal.push(move);
  }
  // Castling is generated fully legal (it already checks every square the king touches).
  for (const move of generateCastling(pos)) legal.push(move);
  return legal;
}

export function isCheck(pos: Position): boolean {
  return isInCheck(pos.board, pos.turn);
}

/** Leaf-node count to `depth` plies — the standard move-generator correctness test. */
export function perft(pos: Position, depth: number): number {
  if (depth === 0) return 1;
  const moves = generateLegalMoves(pos);
  if (depth === 1) return moves.length;
  let nodes = 0;
  for (const move of moves) nodes += perft(applyMove(pos, move), depth - 1);
  return nodes;
}
